export default "__VITE_ASSET__3430cefb__"